/* eslint-disable import/no-unused-modules */

import type { SurchargeConfig } from './type/types';

export const PRIMARY_BUTTON_COLOR = '#D87F5C';

export const proposalProductColumnsClass = 'grid-cols-[43%_17%_11%_13%_5%_11%]';
/** 5-column layout when tax column is hidden (Products | QTY | Unit | Discounted | Price) */
export const proposalProductColumnsClassNoTax =
    'grid-cols-[43%_17%_11%_13%_16%]';
export const proposalQuotePaymentColumnsClass =
    'grid-cols-[56%_12%_10%_10%_12%]';
export const proposalInvoicePaymentColumnsClass =
    'grid-cols-[56%_11%_11%_11%_11%]';

export const SURCHARGE_CONFIG_NZ: SurchargeConfig = {
    rate: 0.027,
    flatFee: 0,
};

export const SURCHARGE_CONFIG_AU: SurchargeConfig = {
    rate: 0.027,
    flatFee: 0,
};

export const SURCHARGE_CONFIG_US: SurchargeConfig = {
    rate: 0.027,
    flatFee: 0,
};

export const SURCHARGE_CONFIG_DEFAULT: SurchargeConfig = {
    rate: 0.01,
    flatFee: 0,
};
